import { render } from "./AboutClinton.vue?vue&type=template&id=0e3c1845"
import script from "./AboutClinton.vue?vue&type=script&lang=js"
export * from "./AboutClinton.vue?vue&type=script&lang=js"

import "./AboutClinton.vue?vue&type=style&index=0&id=0e3c1845&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__